import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

export class UpdateCurrentProjectRolesAction {
  static readonly type = '[Project] Set Current Project role';
  constructor(public payload: ProjectRolesStateModel) { }
}

export class ProjectRolesStateModel {
  projectId?: string;
  roles?: string[];
}

@State<ProjectRolesStateModel>({
  name: 'projectRoles',
  defaults: new ProjectRolesStateModel()
})
@Injectable()
export class ProjectRolesState {

  @Selector()
  static currentProjectRoles(state: ProjectRolesStateModel): ProjectRolesStateModel {
    return state;
  }

  @Action(UpdateCurrentProjectRolesAction)
  updateCurrentProjectRoles(ctx: StateContext<ProjectRolesStateModel>, action: UpdateCurrentProjectRolesAction) {
    ctx.setState(action.payload);
  }
}
